import React from 'react'

import { useAppSelector } from '@app/app.hook'
import { selectStrings } from '@app/slices/slice.app'

import { IDS } from '@fmt/constants'
import { CareProfessionalKeys, CareProfessionalValues } from '@fmt/type'
import { FormikProps } from 'formik'

interface ComponentProps {
    readOnly: boolean
    careprofessionalEditFormik: FormikProps<CareProfessionalValues>
    handleKeyDown: (
        e: React.KeyboardEvent<HTMLInputElement | HTMLSelectElement>,
        fieldName?: CareProfessionalKeys
    ) => void
}

const PhoneNumber = ({ readOnly, careprofessionalEditFormik, handleKeyDown }:ComponentProps) => {
    const strings = useAppSelector(selectStrings)
    const fieldName: CareProfessionalKeys = 'careProfessionalPhoneNumber'

    const result = <div className={'form-group'}>
        <div className={'row mt-3 align-items-center'}>
            <div className={'col-3 d-none d-sm-block'}>
                <label htmlFor={IDS.CAREPROFESSIONAL.EDIT.PHONENUMBER}
                    className={'form-label'}>{
                        strings.fmt?.text.department.menu.phone_number
                    }</label>
            </div>
            <div className={'col-sm-9 col-12'}>
                <input
                    readOnly={readOnly}
                    type={'text'}
                    name={fieldName}
                    className={[
                        'form-control-sm',
                        readOnly ? 'form-control-plaintext' : 'form-control',
                        careprofessionalEditFormik.errors
                            .careProfessionalPhoneNumber && 'border-danger'
                    ].join(' ')}
                    placeholder={!readOnly ? strings.fmt?.text.department.menu.phone_number : ''}
                    value={careprofessionalEditFormik.values.careProfessionalPhoneNumber}
                    id={IDS.CAREPROFESSIONAL.EDIT.PHONENUMBER}
                    onBlur={careprofessionalEditFormik.handleBlur}
                    onChange={!readOnly ? careprofessionalEditFormik.handleChange : () => {}}
                    onKeyDown={(e) => handleKeyDown(e, 'careProfessionalEmail')}
                    required
                />
                <div className={'form-text error'}>{
                    careprofessionalEditFormik.errors.careProfessionalPhoneNumber
                        ? careprofessionalEditFormik.errors.careProfessionalPhoneNumber
                        : null
                }</div>
            </div>

        </div>

    </div>

    return result
}

export default PhoneNumber
